var render = function render(){var _vm=this,_c=_vm._self._c;return _c('o-upload',{attrs:{"loading":_vm.loading,"type":_vm.fileType,"label":_vm.uploadTextContent},on:{"submit":_vm.submit,"deleteFile":_vm.deleteGpxFile},model:{value:(_vm.gpxFile),callback:function ($$v) {_vm.gpxFile=$$v},expression:"gpxFile"}})
}
var staticRenderFns = []

export { render, staticRenderFns }